'use strict';

var through = require('pull-stream/throughs/through');

var countStreamBytes = function countStreamBytes(callback) {
  var bytesRead = 0;
  return through(function (buffer) {
    bytesRead += buffer.length;
    return buffer;
  }, function () {
    callback(bytesRead);
  });
};

module.exports = countStreamBytes;